
<template>
  <div>
    <v-container grid-list-xs>
      <v-card style="border-radius:12px">
        <v-card-title primary-title class="pb-10">
          <div class="headline">Nova Medição</div>
        </v-card-title>
        <v-card-text class="">
          <new-execution-form></new-execution-form>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'CreateExecution',
  components: {
    NewExecutionForm: () => import('./NewExecutionForm.vue')
  },
  data() {
    return {
      
    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>